/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Biaya_S3Inputs */

const en_mk_tut_biaya_s3 = /** @type {(inputs: Mk_Tut_Biaya_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Plan & billing** to see the quota left this month and move up a plan if it is not enough — the next chapter covers it in detail.`)
};

const id_mk_tut_biaya_s3 = /** @type {(inputs: Mk_Tut_Biaya_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka **Paket & tagihan** untuk melihat kuota yang tersisa bulan ini dan menaikkan paket kalau kurang — bab berikutnya membahasnya lebih rinci.`)
};

/**
* | output |
* | --- |
* | "Open **Plan & billing** to see the quota left this month and move up a plan if it is not enough — the next chapter covers it in detail." |
*
* @param {Mk_Tut_Biaya_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_biaya_s3 = /** @type {((inputs?: Mk_Tut_Biaya_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Biaya_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_biaya_s3(inputs)
	return en_mk_tut_biaya_s3(inputs)
});